import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from '../App.tsx';
import './index.css';
import { getBasePath } from '../constants.ts';
import { ErrorBoundary } from '../components/ErrorBoundary.tsx';

// Registro robusto e imediato do Service Worker do PWA para ativação instantânea das APIs nativas
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    let swUrl = 'sw.js';
    let swScope = './';
    try {
      const base = getBasePath();
      if (base && base !== '/') {
        swUrl = base.endsWith('/') ? `${base}sw.js` : `${base}/sw.js`;
        swScope = base.endsWith('/') ? base : `${base}/`;
      }
    } catch (e) {
      swUrl = 'sw.js';
      swScope = './';
    }
    
    navigator.serviceWorker.register(swUrl, { scope: swScope })
      .then((registration) => {
        console.log('PWA Service Worker registrado com sucesso no escopo:', registration.scope);
      })
      .catch((error) => {
        console.log('Erro ou bypass de Service Worker em ambiente de desenvolvimento local:', error);
      });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
